import { Radio } from "@mui/material";
import { CountBadge, SelectableOption } from "@zfp-akademie-a-s/zfp-design";
import { ErrorIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { FC, ReactNode } from "react";

const TILE_HEIGHT = 52;

type Props = {
  readonly value: string;
  readonly icon: ReactNode;
  readonly label: string;
  /** The items of this type, shown in a CountBadge when there are any. */
  readonly count?: number;
  /** Highlights the count of the chosen tile; the RadioGroup's value decides which one that is. */
  readonly isActive?: boolean;
  /** A red border and an error mark in place of the count. */
  readonly error?: boolean;
  readonly disabled?: boolean;
};

// One type to pick in a RadioGroup laid out as a grid, e.g. an income, expense or goal type: the package's option as a
// 52px row with the type's icon, its label and the count of its items. The same tile in every drawer that picks a type.
export const TypeTile: FC<Props> = ({ value, icon, label, count = 0, isActive = false, error = false, disabled = false }) => (
  <SelectableOption
    value={value}
    disabled={disabled}
    error={error}
    control={<Radio icon={icon} checkedIcon={icon} />}
    label={
      <>
        {label}
        {error ? <ErrorIcon sx={{ flexShrink: 0, color: "error.main" }} /> : count > 0 && <CountBadge count={count} isActive={isActive} />}
      </>
    }
    sx={{
      minHeight: TILE_HEIGHT,
      // the tiles stand side by side on white, so they keep a border while idle
      borderColor: "divider",
      "& .MuiFormControlLabel-label": {
        flex: 1,
        minWidth: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: Spacing.M,
      },
    }}
  />
);
